import React from "react";
import PlaceHolder from "./PlaceHolder";

const TablePlaceHolder = ({ count = 1 }) => (
    <tr>
        {[...Array(count)].map((_, i) => (
            <td key={i}>
                <PlaceHolder />
            </td>
        ))}
    </tr>
);

export default TablePlaceHolder;
